import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Building = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M9 7C9 5.34315 10.3431 4 12 4H28C29.6569 4 31 5.34315 31 7V34H34C34.5523 34 35 34.4477 35 35C35 35.5523 34.5523 36 34 36H6C5.44772 36 5 35.5523 5 35C5 34.4477 5.44772 34 6 34H9V7ZM11 34H16V28C16 26.8954 16.8954 26 18 26H22C23.1046 26 24 26.8954 24 28V34H29V7C29 6.44772 28.5523 6 28 6H12C11.4477 6 11 6.44772 11 7V34ZM18 34H22V28H18V34ZM13 10C13 8.89543 13.8954 8 15 8H17C18.1046 8 19 8.89543 19 10V12C19 13.1046 18.1046 14 17 14H15C13.8954 14 13 13.1046 13 12V10ZM17 10H15V12H17V10ZM21 10C21 8.89543 21.8954 8 23 8H25C26.1046 8 27 8.89543 27 10V12C27 13.1046 26.1046 14 25 14H23C21.8954 14 21 13.1046 21 12V10ZM25 10H23V12H25V10ZM13 18C13 16.8954 13.8954 16 15 16H17C18.1046 16 19 16.8954 19 18V20C19 21.1046 18.1046 22 17 22H15C13.8954 22 13 21.1046 13 20V18ZM17 18H15V20H17V18ZM21 18C21 16.8954 21.8954 16 23 16H25C26.1046 16 27 16.8954 27 18V20C27 21.1046 26.1046 22 25 22H23C21.8954 22 21 21.1046 21 20V18ZM25 18H23V20H25V18Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Building;
